// AXIOS
import axios from "axios";

// api url
import {
    apiUrl_forProducts,
    apiUrl_forProductImages,
    apiToken,
} from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get products
export let cancelGetProductsApi;
export async function getProducts(token, query = "") {
    if (token) {
        const products = await axios.get(
            apiUrl_forProducts + "products?" + query,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetProductsApi = c;
                }),
            }
        );
        return products;
    } else {
        console.log("Please add required parameters");
    }
}

// add product
export let cancelAddProductApi;
export async function addProduct(token, productData) {
    if (token && productData) {
        const prods = await axios.post(
            apiUrl_forProducts + "product",
            {
                product_name: productData.product_name,
                sku: productData.sku,
                status: productData.status,
                is_featured: productData.is_featured,
                cost_price: productData.cost_price,
                price: productData.price,
                promo_price: productData.promo_price,
                categories: productData.categories,
                manufacturer_id: productData.brand_id,
                short_description: productData.short_description,
                long_description: productData.long_description,
                description: productData.description,
                stock: productData.stock,
                low_stock: productData.low_stock,
                max_order_quantity: productData.max_order_quantity,
                min_order_quantity: productData.min_order_quantity,
                weight: productData.weight,
                width: productData.width,
                length: productData.length,
                height: productData.height,
                upc: productData.upc,
                meta_title: productData.meta_title,
                meta_description: productData.meta_description,
                variations: productData.variations,
                combinations: productData.combinations,
                attributes: productData.attributes,
                ribbon_label: productData.ribbon_label,
                ribbon_color: productData.ribbon_color,
                ribbon_disable_cart: productData.ribbon_disable_cart,
                ribbon_disable_description:
                    productData.ribbon_disable_description,
                ribbon_position: productData.ribbon_position,
                is_purchasability: productData.is_purchasability,
                preorder_message: productData.preorder_message,
                preorder_date: productData.preorder_date,
                call_for_price: productData.call_for_price,
                call_for_price_label: productData.call_for_price_label,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddProductApi = c;
                }),
            }
        );
        return prods;
    } else {
        console.log("Please add required parameters");
    }
}

// get product details
export let cancelGetProductDetailsApi;
export async function getProductDetails(token, prodId) {
    if (token && prodId) {
        const products = await axios.get(
            apiUrl_forProducts + "product/" + prodId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetProductDetailsApi = c;
                }),
            }
        );
        return products;
    } else {
        console.log("Please add required parameters");
    }
}

// get variation details
export let cancelGetVariationDetailsApi;
export async function getVariationDetails(token, prodId) {
    if (token && prodId) {
        const products = await axios.get(
            apiUrl_forProducts + "variations/" + prodId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetVariationDetailsApi = c;
                }),
            }
        );
        return products;
    } else {
        console.log("Please add required parameters");
    }
}

// get combinations details
export let cancelGetCombinationDetailsApi;
export async function getCombinationDetails(token, prodId) {
    if (token && prodId) {
        const products = await axios.get(
            apiUrl_forProducts + "combinations/" + prodId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetCombinationDetailsApi = c;
                }),
            }
        );
        return products;
    } else {
        console.log("Please add required parameters");
    }
}

// add product
export let cancelEditProductApi;
export async function editProduct(token, productData) {
    if (token && productData) {
        const prods = await axios.put(
            apiUrl_forProducts + "product/" + productData.product_id,
            {
                product_name: productData.product_name,
                sku: productData.sku,
                status: productData.status,
                is_featured: productData.is_featured,
                cost_price: productData.cost_price,
                price: productData.price,
                promo_price: productData.promo_price,
                categories: productData.categories,
                manufacturer_id: productData.brand_id,
                short_description: productData.short_description,
                long_description: productData.long_description,
                description: productData.description,
                stock: productData.stock,
                low_stock: productData.low_stock,
                max_order_quantity: productData.max_order_quantity,
                min_order_quantity: productData.min_order_quantity,
                weight: productData.weight,
                width: productData.width,
                length: productData.length,
                height: productData.height,
                upc: productData.upc,
                meta_title: productData.meta_title,
                meta_description: productData.meta_description,
                variations: productData.variations,
                combinations: productData.combinations,
                attributes: productData.attributes,
                ribbon_label: productData.ribbon_label,
                ribbon_color: productData.ribbon_color,
                ribbon_disable_cart: productData.ribbon_disable_cart,
                ribbon_disable_description:
                    productData.ribbon_disable_description,
                ribbon_position: productData.ribbon_position,
                is_purchasability: productData.is_purchasability,
                preorder_message: productData.preorder_message,
                preorder_date: productData.preorder_date,
                call_for_price: productData.call_for_price,
                call_for_price_label: productData.call_for_price_label,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditProductApi = c;
                }),
            }
        );
        return prods;
    } else {
        console.log("Please add required parameters");
    }
}

// delte product
export let cancelDeleteProductApi;
export async function deleteProduct(token, prodId) {
    if (token && prodId) {
        const products = await axios.delete(
            apiUrl_forProducts + "product/" + prodId,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteProductApi = c;
                }),
            }
        );
        return products;
    } else {
        console.log("Please add required parameters");
    }
}

// add product
export let cancelAddVariantApi;
export async function addVariant(token, data) {
    if (token && data) {
        const prods = await axios.post(
            apiUrl_forProducts + "variation/",
            { data },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddVariantApi = c;
                }),
            }
        );
        return prods;
    } else {
        console.log("Please add required parameters");
    }
}

// add images
export let cancelAddProductImage;
export async function addProductImage(token, data) {
    if (token && data) {
        console.log("imagesd data ", data);
        const prods = await axios.post(
            apiUrl_forProductImages + data.productId,
            data.images,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "content-type": "multipart/form-data",
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddProductImage = c;
                }),
            }
        );
        return prods;
    } else {
        console.log("Please add required parameters");
    }
}

// get products attributes
export let cancelGetProductsAttributesApi;
export async function getProductsAttributes(token) {
    if (token) {
        const attributes = await axios.get(
            apiUrl_forProducts + "global/attributes",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetProductsAttributesApi = c;
                }),
            }
        );
        return attributes;
    } else {
        console.log("Please add required parameters");
    }
}

export let cancelGetProductVaraitonsApi;
export async function getProductVaraitons(token, category = "", keyword) {
    if (token) {
        let query = "";
        if (category) {
            query = "category_id=" + category + "&limit=-1";
        }
        if (keyword) {
            query = "keyword=" + keyword + "&limit=-1";
        }
        if (!category && !keyword) {
            query = "limit=10";
        }
        const products = await axios.get(
            apiUrl_forProducts + "products/combinations?" + query,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetProductVaraitonsApi = c;
                }),
            }
        );
        return products;
    } else {
        console.log("Please add required parameters");
    }
}

// add product
export let cancelChangeProductStatusApi;
export async function handleProductStatusChangeApi(
    token,
    { product_id, status }
) {
    if (token && product_id) {
        const prods = await axios.put(
            apiUrl_forProducts + "product/status/" + product_id,
            { status },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditProductApi = c;
                }),
            }
        );
        return prods;
    } else {
        console.log("Please add required parameters");
    }
}
